import React, {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useState,
} from "react"
import { IoCloseOutline } from "react-icons/io5"

interface AlertContextType {
  showAlert: (
    title: string,
    description: string,
    okButtonTitle: string,
    okButtonPress: () => void,
    cancelButtonTitle: string,
    cancelButtonPress: () => void,
  ) => void
}

const AlertContext = createContext<AlertContextType | undefined>(undefined)

export const useAlert = (): AlertContextType => {
  const context = useContext(AlertContext)
  if (!context) {
    throw new Error("useAlert must be used within an GlobalAlert")
  }
  return context
}

interface AlertProviderProps {
  children: ReactNode
}

export const GlobalAlert: React.FC<AlertProviderProps> = ({
  children,
}): ReactElement => {
  const [alertVisible, setAlertVisible] = useState(false)
  const [alertConfig, setAlertConfig] = useState({
    title: "",
    description: "",
    okButtonTitle: "",
    okButtonPress: () => {},
    cancelButtonTitle: "",
    cancelButtonPress: () => {},
  })

  console.log("alertConfig", alertConfig)

  const showAlert = (
    title: string,
    description: string,
    okButtonTitle: string,
    okButtonPress: () => void,
    cancelButtonTitle: string,
    cancelButtonPress: () => void,
  ) => {
    setAlertConfig({
      title,
      description,
      okButtonTitle,
      okButtonPress,
      cancelButtonTitle,
      cancelButtonPress,
    })
    setAlertVisible(true)
  }

  const hideAlert = () => {
    setAlertVisible(false)
  }

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alertVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-black/40 backdrop-blur-md rounded-2xl shadow-lg text-center max-w-xs md:max-w-sm">
            <div className="flex self-end justify-end">
              {/* <div
                onClick={() => hideAlert()}
                className="pointer-events-auto cursor-pointer focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
              >
                <IoCloseOutline size={26} />
              </div> */}
            </div>
            <div className="pt-6">
              <p className="mb-4 text-white text-lg px-6">
                {alertConfig.title}
              </p>
              <p className="mb-4 text-white px-6">{alertConfig.description}</p>
              <div className="flex justify-center items-center flex-col border-t border-white/10 text-red-800 font-semibold">
                <button
                  onClick={() => {
                    alertConfig.okButtonPress()
                    hideAlert()
                  }}
                  className="py-4 rounded-full bg-transparent border text-lg"
                >
                  {alertConfig.okButtonTitle}
                </button>
              </div>
              <div className="flex justify-center items-center flex-col border-t border-white/10 font-semibold">
                <button
                  onClick={() => {
                    alertConfig.cancelButtonPress()
                    hideAlert()
                  }}
                  className="bg-transparent text-blue-800 pt-4 pb-6 rounded-full  border-none text-lg"
                >
                  {alertConfig.cancelButtonTitle}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  )
}
